import { LanguageService } from '@philips-internal/oswald-ui-core/lib/services';

export class NumberFormatUtils {
  /**
   * Returns the number formatted as a string considering the establishment's locale.
   * @param value String
   * @returns
   */
  static formatToCurrentLanguage(value: number, currencySymbol?: string): string {
    const locale = LanguageService.getCurrentLanguage().replace('_', '-');
    const formattedValue = new Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(value);
    return currencySymbol ? currencySymbol + formattedValue : formattedValue;
  }
}